import { ICONS } from "constants/icons";
import Icon from "Components/Icon/Icon";
import Loader from "Components/Loader/Loader";
import { StartScreenWrapper } from "Containers/Screens/StartScreen/StartScreen.styled";

const StartScreen = () => {
    return (
        <StartScreenWrapper>
            <Icon name={ICONS.WINDOWS} />
            <Loader />
        </StartScreenWrapper>
    );
};

export default StartScreen;
